// extracted by mini-css-extract-plugin
export default {"refetch":"refetch_refetch__00i8-","refresh_icon":"refetch_refresh_icon__PSabC"};